
export class CPQUI{
  constructor() {
    this.Pages = [];
    this.Messages = [];
    this.Details = [];
    this.OptionToFocus = "";
    this.SelectionSummary = [];
  }

  public Pages: CPQPage[];
  public OptionToFocus: string;
  public Messages: CPQMessage[];
  public Details: CPQDetail[];
  public SelectionSummary: CPQSelectionSummary[];
}

export class CPQPage {
  constructor() {
    this.IsVisible = true;
  }

  public Caption: string;
  public IsVisible: boolean;
  public Screens: CPQScreen[];
  public Active: boolean;
  public Index: number;
  public ID: string;
}



export class CPQScreen {
  constructor() {
    this.IsVisible = true;
  }
  public Caption: string;
  public Description: string;
  public ImageLink: string;
  public IsVisible: boolean;
  public ScreenOptions: CPQScreenOption[];
  
}

export class CPQScreenOption {
  constructor() {
    this.IsVisible = true;
    this.IsValid = true;
  }
  public AutoContinueMode: number;
  public DisplayType: string;
  public ID: string;
  public Description: string;
  public IsRequired: boolean;
  public Name: string;
  public SelectableValues: CPQScreenOptionValue[];
  public Ranges: CPQOptionRange[];
  public Value: string;
  public IsEnabled: boolean;
  public Caption: string;
  public IsVisible: boolean;
  public ShowCaption: boolean;
  public ShowDescription: boolean;
  public ShowSeparator: boolean;
  public IsValid: boolean;

  public NumericValue: number;
}

export class CPQScreenOptionValue {
  constructor() {
    this.IsVisible = true;
  }

  public Caption: string;
  public ImageLink: string;
  public IsVisible: boolean;
  public Value: string;
}

export class CPQOptionRange {
  constructor() {}

  public Increment: number;
  public Min: number;
  public Max: number;
}


export class CPQMessage {
  constructor() {}
  public Value: string;
}

export class CPQDetail {
  constructor() { }

  public Caption: string;
  public Value: string;
  public Type: number;
}

export class CPQSelectionSummary {
  constructor() { }

  public Caption: string;
  public Value: string;
}

export class CPQSelectableValue {
  constructor() {

  }
  public SelectableValue: string;
  public ValueIsEnabled: boolean;
  public ValueIsVisible: boolean;
  public Value: string;
}
